/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyFolderIcon = createIcon("EmptyFolderIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M79 52v-5.995A2.002 2.002 0 0077.002 44H48.996a.99.99 0 01-.997-.99l-.002-3.012A2 2 0 0046.003 38H28.994A2.006 2.006 0 0027 40.005v41.994S27 88 31.99 88h45.005A2.005 2.005 0 0079 85.995V52L31.99 88H82c5 0 5-6 5-6V53.992A1.99 1.99 0 0085.002 52H79Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 35.001c0-1.105.89-2.001 1.997-2.001h15.006A2 2 0 0153 34.998v3.011c0 .547.438.991.996.991h28.006A2 2 0 0184 40.998v38.005C84 80.105 83.11 81 82.01 81H35.99A1.995 1.995 0 0134 78.999V35Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 75.999S35 80 37.99 80h44.007C82.55 80 83 79.55 83 78.991V41.01a.998.998 0 00-.996-1.01H53.998A2 2 0 0152 38.002v-3.011A1 1 0 0051 34H36c-.552 0-1 .443-1 .997v41.002ZM83.002 38c1.103 0 1.998.899 1.998 2.005v39.99A2.005 2.005 0 0182.995 82H37.991C33 82 33 75.999 33 75.999V34.005c0-1.107.902-2.005 1.994-2.005h17.008a2 2 0 011.995 1.998L54 37.009c0 .547.44.991.997.991h28.006Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 76s0 4-3 4v2h50c5 0 5-6 5-6V47.992c0-1.1-.903-1.992-2.007-1.992H43.007A2.003 2.003 0 0041 47.992V76Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 76s0 4-2 4h47c3 0 3-4 3-4V48.996A.997.997 0 0089.998 48H44.002a.996.996 0 00-1.002.996V76Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.EmptyFolderIcon"
});